import { Paper, Title, Text } from "@mantine/core";
import { FormattedMessage } from "react-intl";
import { ContactDetails } from "./contactDetails";
import { isMobileDevice } from "../../utils/useDeviceDetection";

const ContactUsPaper = () => {
  const isMobile = isMobileDevice();

  return (
    <Paper p={isMobile ? "lg" : "xl"} radius={"lg"} mb={"xl"}>
      <Title order={4} mb={"lg"} ff={"var(--wallet-font-family-sambla-sans)"}>
        <FormattedMessage
          id="customerSummary.contactCard.title"
          defaultMessage="Har du frågor?"
        />
      </Title>
      <Text mb={"2rem"}>
        <FormattedMessage
          id="customerSummary.contactCard.paragraph"
          defaultMessage="Do you have questions?"
        />
      </Text>
      <ContactDetails />
    </Paper>
  );
};

export default ContactUsPaper;
